export const apiRoutes = {
  api_r_user_module_communicationPipeline_getModuleData: {
    path: 'm/communication-pipeline/get-module-data/',
  },
  api_r_user_module_communicationPipeline_report_get: {
    path: 'm/communication-pipeline/report/get/',
  },
  api_r_user_module_communicationPipeline_report_communication_list: {
    path: 'm/communication-pipeline/report/communication/list/',
  },
  api_r_user_module_communicationPipeline_report_communication_add: {
    path: 'm/communication-pipeline/report/communication/add/',
  },
  api_r_user_module_communicationPipeline_report_communication_file_get: {
    path: 'm/communication-pipeline/report/communication/file/get/',
  },
  api_r_user_module_communicationPipeline_report_file_get: {
    path: 'm/communication-pipeline/report/file/get/',
  },
  api_r_user_module_communicationPipeline_report_status: {
    path: 'm/communication-pipeline/report/status/',
  },
  api_r_user_module_communicationPipeline_report_communication_alerts: {
    path: 'm/communication-pipeline/report/communication/alerts/',
  },
  api_r_user_module_communicationPipeline_inquiry_communication_list: {
    path: 'm/communication-pipeline/inquiry/communication/list/',
  },
  api_r_user_module_communicationPipeline_inquiry_add: {
    path: 'm/communication-pipeline/inquiry/add/',
  },
  api_r_user_module_communicationPipeline_inquiry_communication_add: {
    path: 'm/communication-pipeline/inquiry/communication/add/',
  },
  api_r_user_module_communicationPipeline_inquiry_communication_file_get: {
    path: 'm/communication-pipeline/inquiry/communication/file/get/',
  },
  // ADMIN
  api_r_user_module_communicationPipeline_admin_report_list: {
    path: 'm/communication-pipeline/admin/report/list/',
  },
  api_r_user_module_communicationPipeline_admin_report_status_edit: {
    path: 'm/communication-pipeline/admin/report/status/edit/',
  },
  api_r_user_module_communicationPipeline_admin_report_evidence_add: {
    path: 'm/communication-pipeline/admin/report/evidence/add/',
  },
  api_r_user_module_communicationPipeline_admin_report_evidence_delete: {
    path: 'm/communication-pipeline/admin/report/evidence/delete/',
  },
  api_r_user_module_communicationPipeline_admin_report_evidence_file_get: {
    path: 'm/communication-pipeline/report/evidence/file/get/',
  },
  api_r_user_module_communicationPipeline_report_thread_list: {
    path: 'm/communication-pipeline/report/thread/list/',
  },
  api_r_user_module_communicationPipeline_report_thread_add: {
    path: 'm/communication-pipeline/report/thread/add/',
  },
  api_r_user_module_communicationPipeline_admin_inquiry_list: {
    path: 'm/communication-pipeline/admin/inquiry/list/',
  },
  api_r_user_module_communicationPipeline_admin_communication_alerts: {
    path: 'm/communication-pipeline/admin/communication/alerts/',
  },
  // USER
  api_r_user_module_communicationPipeline_user_report_add: {
    path: 'm/communication-pipeline/user/report/add/',
  },
  api_r_user_module_communicationPipeline_user_report_auth: {
    path: 'm/communication-pipeline/user/report/auth/',
  },
  api_r_user_module_communicationPipeline_user_report_auth_check: {
    path: 'm/communication-pipeline/user/report/auth/check/',
  },
  api_r_user_module_communicationPipeline_user_report_recover_password: {
    path: 'm/communication-pipeline/user/report/recover-password/',
  },
  api_r_user_module_communicationPipeline_user_inquiry_add: {
    path: 'm/communication-pipeline/user/inquiry/add/',
  },
};
